export function parseLocalizedNumber(value) {
  if (value === null || typeof value === 'undefined') {
    return Number.POSITIVE_INFINITY;
  }

  const normalizedValue = String(value)
    .trim()
    .replace(/^</, '')
    .replace(/\s+/g, '')
    .replace(',', '.');

  const parsedValue = Number(normalizedValue);

  return Number.isNaN(parsedValue)
    ? Number.POSITIVE_INFINITY
    : parsedValue;
}

export function getResultSortMeta(value) {
  const rawValue = String(value ?? '').trim();

  return {
    rawValue,
    isLessThan: rawValue.startsWith('<'),
    numericValue: parseLocalizedNumber(rawValue),
  };
}

export function compareResultSortMeta(leftValue, rightValue, desc) {
  if (
    leftValue &&
    rightValue &&
    typeof leftValue === 'object' &&
    typeof rightValue === 'object' &&
    'numericValue' in leftValue &&
    'numericValue' in rightValue
  ) {
    if (leftValue.numericValue !== rightValue.numericValue) {
      const comparison =
        leftValue.numericValue > rightValue.numericValue ? 1 : -1;
      return desc ? comparison * -1 : comparison;
    }

    if (leftValue.isLessThan !== rightValue.isLessThan) {
      const comparison = leftValue.isLessThan ? -1 : 1;
      return desc ? comparison * -1 : comparison;
    }

    if (leftValue.rawValue !== rightValue.rawValue) {
      const comparison = leftValue.rawValue > rightValue.rawValue ? 1 : -1;
      return desc ? comparison * -1 : comparison;
    }
  }

  if (leftValue === rightValue) return 0;

  const comparison = leftValue > rightValue ? 1 : -1;
  return desc ? comparison * -1 : comparison;
}
